import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import CommentSection from './CommentSection';
import './PageView.css';

const PageView = () => {
  const { slug } = useParams();
  const { pages, loading, error } = useContent();
  const [page, setPage] = useState(null);

  useEffect(() => {
    if (pages && pages.length > 0) {
      const foundPage = pages.find(p => p.slug === slug);
      setPage(foundPage);
    }
  }, [pages, slug]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <span>Loading professional profile...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">
          Error loading profile: {error}
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="not-found-container">
        <h1>Profile Not Found</h1>
        <p>The requested professional profile could not be found.</p>
      </div>
    );
  }

  return (
    <div className="page-view">
      {/* Professional Header */}
      <header className="page-header">
        <h1>{page.title}</h1>
        {page.description && (
          <div className="page-description">
            <div className="ql-snow">
              <div 
                className="ql-editor" 
                dangerouslySetInnerHTML={{ __html: page.description }} 
              />
            </div>
          </div>
        )}
      </header>
      
      {/* Professional Content Sections */}
      {page.Sections && page.Sections.length > 0 && (
        <main className="sections">
          {(page.Sections || [])
            .sort((a, b) => a.order - b.order)
            .map(section => (
            <section key={section.id} className="section">
              <h2>{section.title}</h2>
              {section.description && (
                <div className="section-description">
                  <div className="ql-snow">
                    <div 
                      className="ql-editor" 
                      dangerouslySetInnerHTML={{ __html: section.description }} 
                    />
                  </div>
                </div>
              )}
              
              {/* Professional Cards/Experience Items */}
              {section.Cards && section.Cards.length > 0 && (
                <div className="cards">
                  {(section.Cards || [])
                    .sort((a, b) => a.order - b.order)
                    .map(card => (
                    <article key={card.id} className="card">
                      <h3>{card.title}</h3>
                      {card.content && (
                        <div className="card-content">
                          <div className="ql-snow">
                            <div 
                              className="ql-editor" 
                              dangerouslySetInnerHTML={{ __html: card.content }} 
                            />
                          </div>
                        </div>
                      )}
                      {card.imageUrl && (
                        <div className="card-image">
                          <img src={card.imageUrl} alt={card.title} />
                        </div>
                      )}
                      {card.fileUrl && (
                        <div className="card-file">
                          <a 
                            href={`/api/upload/download/${card.fileUrl.split('/').pop()}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                            download={card.originalName || card.fileUrl.split('/').pop()}
                          >
                            {card.originalName || 'Download Document'}
                          </a>
                        </div>
                      )}
                    </article>
                  ))}
                </div>
              )}
            </section>
          ))}
        </main>
      )}
      
      {/* Professional Comments Section */}
      {page && (
        <footer className="comments-section">
          <CommentSection pageId={page.id} />
        </footer>
      )}
    </div>
  );
};

export default PageView; 